export default "__VITE_ASSET__B1UZki9Y__"